export function showChameleonExperience(experienceNameOrId: string) {
    if (!window.chmln) {
        return;
    }
    window.chmln.show?.(experienceNameOrId);
}
